// extracted by mini-css-extract-plugin
module.exports = {"label":"ResetPasswordForm_label__1sfgH","btn":"ResetPasswordForm_btn__OKA1o","hint":"ResetPasswordForm_hint__27iZF"};